module.exports = "https://static.wmbcdn.com/uniweb/images/9603e1239701117482c2a9f742d93def.svg";